import { render, staticRenderFns } from "./TermList.vue?vue&type=template&id=10d11fea&scoped=true&"
import script from "./TermList.vue?vue&type=script&lang=ts&"
export * from "./TermList.vue?vue&type=script&lang=ts&"
import style0 from "./TermList.vue?vue&type=style&index=0&id=10d11fea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d11fea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
